export default __webpack_public_path__ + "static/media/heartbeat.ce80ce2e.svg";